import React, { Component } from 'react';
import { Tooltip, Input, Table } from 'antd';
import CpLogo from '../../components/CpLogo';
import Swiper from './components/swiper';
import classnames from 'classnames';
import './index.less';
import send from '../../util/request';
const { Search } = Input;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      categoryList: [],
      currentId: '',
      tableData: [],

      inputValue: '',
      total: 0,
      page_size: 10,
      total_page: 1,
      current: 1
    };
  }
  columns = [
    {
      title: '基地名称',
      dataIndex: 'name',
      key: 'name',
      width: 300,
      render: (text, record) => <Tooltip title={text}><div className='location-name' onClick={() => this.goToDetail(record.id)}>{text}</div></Tooltip>
    },
    {
      title: '占地面积',
      dataIndex: 'area_covered',
      key: 'area_covered',
      width: 160
    },
    {
      title: '产地',
      dataIndex: 'place',
      key: 'place',
      width: 100,
    },
    {
      title: '主营产品',
      align: 'center',
      render: (text, record) => {
        return <Swiper products={record.product || []}></Swiper>;
      }
    }
  ]
  goToDetail = id => {
    this.props.history.push(`/basic/location/detail/${id}`);
  }
  componentDidMount() {
    this.getCategory();
    this.getList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  getCategory = async () => {
    const { data: { data = {}, code }, } = await send({ url: '/ipp/base/category' });
    if (+code === 0) {
      const { list = [] } = data;
      this.setState({ categoryList: [{ category_name: '全部', id: '' }, ...list] });
    }
  }
  getList = async () => {
    const { currentId, inputValue, current, page_size } = this.state;
    const { data: { data = {}, code }, } = await send({ url: '/ipp/base/select', params: { category_id: currentId, product_name: inputValue, page: current, page_size }, options: { loading: true } });
    if (+code === 0) {
      const { list = [], total, page_size, total_page } = data;
      this.setState({ tableData: list, total, page_size, total_page });
    }
  }
  changeCategory = (id) => {
    this.setState({ currentId: id, current: 1 }, () => this.getList());
  }
  inputChanged = e => {
    this.setState({ inputValue: e.target.value });
  }
  onSearch = value => {
    this.setState({ current: 1 }, () => {
      this.getList();
    });
  };
  onPageChange = current => {
    this.setState({ current }, () => { this.getList(); });
  }
  changePageSize = (pageSize, current) => {
    this.setState({ current, page_size: pageSize }, () => this.getList());
  }
  render() {
    const { categoryList = [], currentId, tableData, total, page_size, current, inputValue } = this.state;
    return (
      <div style={{background:'white'}}>
        <div className="location-header">
          <CpLogo></CpLogo>
          <div className="cp-search">
            <Input.Group compact>
              <Search
                value={inputValue}
                placeholder="请输入主要产品"
                enterButton="搜索 "
                size="large"
                onChange={(e) => { this.inputChanged(e); }}
                onSearch={this.onSearch}
              />
            </Input.Group>
          </div>
        </div>
        <div className="location-category">
          <span className="location-category-title">主营产品分类</span>
          <div className='location-category-list'>
            {categoryList.map((item) => {
              return (
                <span
                  key={item.id}
                  onClick={() => { this.changeCategory(item.id); }}
                  className={classnames({
                    'location-category-item': true,
                    active: currentId === item.id,
                  })}
                > {item.category_name} </span>
              );
            })}
          </div>
        </div>
        <div className='location-table'>
          <Table
            rowKey={record => record.id}
            columns={this.columns}
            dataSource={tableData}
            pagination={{
              pageSize: page_size,
              current,
              showTotal: () => `共${total}条`,
              total: total,
              onChange: current => this.onPageChange(current),
              onShowSizeChange: (current, pageSize) => this.changePageSize(pageSize, current),
            }}
          />
        </div>
      </div>
    );
  }
}

export default Index;